import * as React from 'react';
import { Loader } from 'Src/components/Loader/Loader';
import { AppUser } from 'Src/views/App/App';
import { ChildrenTeamsOverview, getChildrenCurrentTeams } from 'Src/helpers/service/parent/teams';
import { ParentPageHeader } from '../components/ParentPageHeader';
import '../../StudentView/Teams/StudentTeams.scss';
import './ChildrenTeams.scss';
import { TeamMembershipCard } from '../../StudentView/Teams/TeamMembershipCard';
import { ItemsBar } from '../Calendar/ItemsBar';

export const ChildrenTeams = ({ user }: { user: AppUser }) => {
  const [data, setData] = React.useState<ChildrenTeamsOverview | null>(null);
  const [selectedChildIds, setSelectedChildIds] = React.useState<string[]>([]);
  React.useEffect(() => {
    let mounted = true;
    getChildrenCurrentTeams(user)
      .then(value => { if (mounted) { setData(value); setSelectedChildIds(value.children.map(child => child.id)); } })
      .catch(() => mounted && setData({ total: 0, season: '', children: [] }));
    return () => {
      mounted = false;
    };
  }, [user.roleSessionKey, user.activeSchoolId]);
  if (!data) return <Loader />;
  const visibleChildren = data.children.filter(child => selectedChildIds.includes(child.id));
  const selectChild = (id: string) => setSelectedChildIds(id === 'all' ? data.children.map(child => child.id) : [id]);
  return (
    <main className="parentPage parentTeamsPage">
      <ParentPageHeader
        title="Children’s teams"
        subtitle="Current school team memberships for your children."
        chips={[
          { value: data.total, label: data.total === 1 ? 'team' : 'teams', tone: 'blue' },
          { value: data.children.length, label: data.children.length === 1 ? 'child' : 'children', tone: 'green' },
          { label: data.season, tone: 'slate' }
        ]}
      />
      <ItemsBar items={data.children} itemIdList={selectedChildIds} onClick={selectChild} allItemsTitle="All children" getItemName={child => `${child.firstName} ${child.lastName}`} showItemCounts={false} />
      <div className="studentTeamsGrid">
      {visibleChildren.map(child => (
        <React.Fragment key={child.id}>
            {child.teams.map(team => (
              <TeamMembershipCard team={team} viewerUserId={child.id} subjectName={`${child.firstName} ${child.lastName}`} relationshipLabel="Your child" ageGroupsNaming={(user as any).activeSchool?.ageGroupsNaming} key={`${child.id}-${team.id}`} />
            ))}
        </React.Fragment>
      ))}
      </div>
      {!data.total && (
        <div className="studentTeamsEmpty">
          <h2>No current teams</h2>
          <p>None of your linked children are currently included in a school team roster.</p>
        </div>
      )}
    </main>
  );
};
